import React from "react"

import {TPFLContext, TSalesCycleWithAdvancedSearch} from "../types.ts"

export const usePFLContext = (onClose: () => void, salesCycle: TSalesCycleWithAdvancedSearch): TPFLContext => {
  const [isFiltersOpen, setIsFiltersOpen] = React.useState(true)
  const [isAdvancedFiltering, setIsAdvancedFiltering] = React.useState(salesCycle.advanced_search_enabled)

  return React.useMemo(
    () => ({
      isFiltersOpen,
      setIsFiltersOpen,
      isAdvancedFiltering,
      setIsAdvancedFiltering,
      onClose,
    }),
    [isAdvancedFiltering, isFiltersOpen, onClose]
  )
}
